import React, { InputHTMLAttributes, PropsWithChildren } from "react";

interface LabelProps extends InputHTMLAttributes<HTMLLabelElement> {
  /** Name is used in the input elements id and labels elements for values to create a unique
   * label + input pair. If the name is not unique it will cause accessibility issues.
   * Usually you want to name the input after the data it will contain e.g mobile-number,
   * first-name, preferred-name etc. */
  name: string;
  /** Standard HTML input required attribute. When not present or false `(optional)` text will display in the inputs label. */
  required?: boolean;
}

export const Label: React.FC<PropsWithChildren<LabelProps>> = ({
  children,
  name,
  required,
}) => {
  return (
    <label htmlFor={name} className="label">
      {children} {!required && "(optional)"}
    </label>
  );
};
